// Copyright Epic Games, Inc. All Rights Reserved.

import React from "react";
import { Typography } from "@material-ui/core";
import {
  useErrorCodeDescription,
  useIsRTL,
} from "../../../store/localization/hooks";

export interface IErrorDescriptionProps {
  errorCode: string;
}

export function ErrorDescription({
  errorCode,
}: IErrorDescriptionProps): JSX.Element {
  const message = useErrorCodeDescription(errorCode);
  const isRTL = useIsRTL();

  return (
    <Typography
      variant="caption"
      style={{
        width: "290px",
        display: "block",
        textAlign: isRTL ? "center" : "left",
      }}
    >
      {message}
    </Typography>
  );
}
